import type { ButtonHTMLAttributes, ComponentChildren } from "preact";
import { cx } from "./lib/cx.ts";

/**
 * A button that reads as a link: it acts in place (opens a panel, selects a
 * row) rather than navigating. Rule: navigation is a real link; use this only
 * when the action isn't a URL. `truncate` keeps one line in a table cell and
 * ends it with an ellipsis; the full text belongs in a `title`.
 */
export function LinkButton({ truncate, children, class: className, ...rest }: { truncate?: boolean; children: ComponentChildren; class?: string } & Omit<ButtonHTMLAttributes<HTMLButtonElement>, "class" | "children">) {
  return (
    <button type="button" {...rest} class={cx("ui-linkbtn", truncate && "ui-linkbtn--truncate", className)}>
      {children}
    </button>
  );
}
